import HeaderWrapperMobile from "./header-wrapper-mobile"
import LogoPart from "./_parts/logo-part"

const StandardHeaderMobile = () => {
  return (
    <div>
      <HeaderWrapperMobile>
        <div className="mr-auto">
          <LogoPart />
        </div>
      </HeaderWrapperMobile>
    </div>
  )
}

export default StandardHeaderMobile
